import React, { useState, } from 'react';
import {
  Button,
  TextField,
  InputAdornment,
  IconButton,
  Grid,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Box,
  Tabs,
  Tab,
  Tooltip
} from '@material-ui/core';
import { History } from '@material-ui/icons';
import { useStyles } from '../DailyScheduleMapViewStyles'; // Extract styles
import moment from 'moment'
import ServiceHistoryModal from './ServiceHistoryModal';

export const InfoItem = ({ label, value, centerItem, clickable, style }) => {
  const classes = useStyles();
  let dynamicInputStyle = centerItem ? { textAlign: 'center' } : null
  let allStyle = {
    ...dynamicInputStyle,
    ...style
  }
  // console.log('The style...', allStyle)
  if (clickable) {
    return (
      <div className={classes.infoItemClickable} onClick={clickable}>
        <Typography className={classes.infoValue} style={ allStyle }>{value}</Typography>
        <Typography className={classes.infoLabel} style={ allStyle }>{label}</Typography>
      </div>
    );
  } else {
    return (
      <div className={classes.infoItem} >
        <Typography className={classes.infoValue} style={ allStyle }>{value}</Typography>
        <Typography className={classes.infoLabel} style={ allStyle }>{label}</Typography>
      </div>
    );
  }

};

export const WeeklyHoursDisplay = ({ weeklyHours, handleDayClick, selectedDay }) => {
  if (!weeklyHours) return null;

  const days = ['M', 'T', 'W', 'Th', 'F'];
  const fullDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #ccc', paddingTop: '10px', marginTop: '10px' }}>
      {days.map((day, index) => (
        <div 
          key={day}
          style={{
            textAlign: 'center', 
            flex: 1, 
            cursor: 'pointer',
            backgroundColor: fullDays[index] === selectedDay ? '#e0e0e0' : 'transparent',
            borderRadius: '4px',
            padding: '2px'
          }}
          onClick={(e) => handleDayClick(fullDays[index], e)}
        >
          <div style={{ fontWeight: 'bold' }}>{day}</div>
          <div>{Math.round(100 * Number(weeklyHours[fullDays[index]].serviceTime + weeklyHours[fullDays[index]].driveTime)) / 100}</div>
        </div>
      ))}
    </div>
  );
};

export const ClosestLocationDetails = (props) => {
  // console.log('Nearest site details', props)
  console.log('ClosestLocationDetails props:', props);
  console.log('jobSiteDetails:', props?.jobSiteDetails);
  console.log('nearestSites:', props?.jobSiteDetails?.nearestSites);
  
  const classes = useStyles();
  const [tabValue, setTabValue] = useState(0);
  // console.log('Closest Location Details', props)
  const longtermFrequencies = [
    'Monthly',
    'Quarterly',
    'Semi-Annually',
    'Annual',
    'On Demand',
    'On-Demand'
  ]
  if (!props?.jobSiteDetails?.nearestSites?.length) return null
  
  const {
    nearestSites = [],
    lastWorkorder,
  } = props?.jobSiteDetails
  if (!nearestSites?.length) return null

  const site = props.site
  console.log('nearestSites...', nearestSites)
  console.log('props.jobSite', props.jobSiteDetails)
  console.log('site', site)
  let filteredSites = nearestSites.filter(item => {
    let includeThis = false
    if (!item.crew || item?.crewName === 'Unassigned') return false
    if (item._id !== site._id) {
      // console.log('Not our active marker...', item)
      // console.log('Site.frequency', site.frequency)
      const isNotRegular = longtermFrequencies.includes(site.frequency)
      const itemIsNotRegular = longtermFrequencies.includes(item.frequency)
      // console.log('Site is not regular:  %s   Item is Not Regular: %s ', isNotRegular, itemIsNotRegular)
      if (!longtermFrequencies.includes(site.frequency)) {
        // Short term frequency - dont show our longterms
        includeThis = !longtermFrequencies.includes(item.frequency)
        // console.log('Do we include this thing???', includeThis, item.frequency)
      } else {
        // console.log('Include this thing....', site.frequency)
        includeThis = true
      }
      // if (site.frequency === item.frequency) includeThis = true
    }
    // if (includeThis) {
    //   let crew = props?.crews.find(crewItem => (crewItem._id === site.crew))
    //   if (crew?._id) site.crewName = `${crew.name} ${crew.foremanName ? `(${crew.foremanName})` : ''}`
    // }
    return includeThis
  }).slice(0, 10)
  
  console.log('1379 filtered sites', filteredSites)
  let closestMatchSites = nearestSites.filter(item => {
    if (!item.crew || item?.crewName === 'Unassigned') return false
    let includeThis = false
    if (item._id !== site._id) {
      if (site.frequency === item.frequency) includeThis = true
    }
    return includeThis
  }).slice(0, 10)

  let perfectMatches = nearestSites.filter(item => {
    if (!item.crew || item?.crewName === 'Unassigned') return false
    let includeThis = false
    // console.log('Seek Perfect Matches', site)
    if (item._id !== site._id && item?.crewName !== 'Unassigned' ) {
      // console.log('This one might work', item)
      if (site.frequency === item.frequency) {
        // console.log('Frequency Match')
        if (site.preferredDay === item.preferredDay) {
          // console.log('Days Match')
          if (site.frequency === 'Bi-Weekly') {
            if (site.evenOrOddWeeks === item.evenOrOddWeeks) {
              // console.log('Even or odd matches')
              includeThis = true
            }
          } else {
            includeThis = true
          }
        }
      }
    }
    return includeThis
  }).slice(0, 10)

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  if (!props?.jobSiteDetails?.nearestSites?.length) {
    return (
      <div style={{ padding: 20, textAlign: 'center' }}>
        <Typography variant="body2" color="textSecondary">
          No nearby sites data available
        </Typography>
      </div>
    );
  }

  // console.log('Perfect Matches', perfectMatches)
  return (
    <div className={classes.tabsRoot}>
      <Paper square>
        <Tabs
          value={tabValue}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleTabChange}
          aria-label="closest sites tabs"
        >
          <Tab label="Closest Sites" />
          <Tab label="Closest Matching Sites" />
          <Tab label="Perfect Matches" />
        </Tabs>
      </Paper>
      <TabPanel value={tabValue} index={0}>
        <Typography variant="h6" gutterBottom>Nearest Locations:</Typography>
        <SiteList 
          nearestSites={filteredSites} 
          handleClickOnSiteNearby={props.handleClickOnSiteNearby}
          highlightedNearbySite={props.highlightedNearbySite}
        />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <Typography variant="h6" gutterBottom>Nearest Matching Locations:</Typography>
        <SiteList 
          nearestSites={closestMatchSites} 
          handleClickOnSiteNearby={props.handleClickOnSiteNearby}
          highlightedNearbySite={props.highlightedNearbySite}
        />
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <Typography variant="h6" gutterBottom>Perfect Matching Locations:</Typography>
        <SiteList 
          nearestSites={perfectMatches} 
          handleClickOnSiteNearby={props.handleClickOnSiteNearby}
          highlightedNearbySite={props.highlightedNearbySite}
        />
      </TabPanel>
    </div>
  )
}


export const ActiveMarkerDetails = ({ activeMarker, jobSiteDetails, clickOnDate, url }) => {
  const classes = useStyles();
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  
  console.log('Jobsite details:', jobSiteDetails)
  const nextSuggestedDate = jobSiteDetails?.nextSuggestedDate ? moment(jobSiteDetails.nextSuggestedDate).format('ddd MM/DD/YY') : null
  console.log('Next Suggested Date', nextSuggestedDate)
  const lastServiceDate = (() => {
    const wo = jobSiteDetails?.lastWorkorder;
    if (!wo) return null;
    console.log('...whos that crew??', wo)
    const scheduled = wo.scheduledDate ? moment(wo.scheduledDate) : null;
    const completed = wo.work_complete_at ? moment(wo.work_complete_at) : null;
  
    if (scheduled && completed) {
      return moment.max(scheduled, completed).format('ddd MM/DD/YY');
    }
  
    return (scheduled || completed)?.format('ddd MM/DD/YY') || null;
  })();
  console.log('Last Service Date', lastServiceDate)  
  // const lastServiceDate = (jobSiteDetails?.lastWorkorder && jobSiteDetails?.lastWorkorder?.work_complete_at) ? moment(jobSiteDetails?.lastWorkorder?.work_complete_at).format('ddd MM/DD/YY') : (jobSiteDetails?.lastWorkorder && jobSiteDetails?.lastWorkorder?.scheduledDate) ? moment(jobSiteDetails?.lastWorkorder?.scheduledDate).format('ddd MM/DD/YY') : null
  const addy = `${activeMarker?.communityName ? activeMarker.communityName : ''} ${ activeMarker?.address } ${activeMarker?.buildingNumber ? `(Bldg #${activeMarker.buildingNumber})` : ''} ${activeMarker?.city} `
  
  const handleSuggestedDateClick = () => {
    // console.log('Click on suggested date')
    clickOnDate(jobSiteDetails.nextSuggestedDate)
  }
  const handleNavToClient = () => {
    console.log('nav to this ', activeMarker)
    let url = `/clients/${activeMarker?.client}`
    console.log('url', url)
    window.open(url, "_blank")
  }
  return (
    <>
    <Paper className={classes.activeMarkerContainer}>
      
        <div className={classes.flexRow}>
          <InfoItem 
            label="Site Name" 
            value= { activeMarker?.name }
            centerItem
            style={{ color: '#516e76' }}
            clickable={handleNavToClient}
          />
          <InfoItem 
            label="Site Address" 
            value= { addy }
            centerItem
          />
        </div>
        <div className={classes.flexRow}>
            <InfoItem 
                label="Frequency" 
                centerItem
                value={`${activeMarker?.frequency} ${activeMarker?.frequency === 'Bi-Weekly' ? `(${activeMarker.evenOrOddWeeks})` : ''}`} 
              />
               <InfoItem 
                label="Preferred Day"
                centerItem 
                value={`${activeMarker?.preferredDay}`} 
              />
                <InfoItem 
                label="Estimated hours" 
                value={`${activeMarker?.estimatedHours || ''}`} 
                centerItem
              />
               {/* <InfoItem 
                label="# of Services to Schedule" 
                value={`${jobSiteDetails?.totalServicesRemaining || ''}`} 
                centerItem
              /> */}
               <InfoItem 
                label={
                  <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    Last Service Date
                    {lastServiceDate && (
                      <Tooltip title="View service history">
                        <IconButton 
                          size="small" 
                          onClick={(e) => {
                            e.stopPropagation();
                            setHistoryModalOpen(true);
                          }}
                          style={{ marginLeft: 4, padding: 2 }}
                        >
                          <History fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </span>
                }
                centerItem
                value={`${ lastServiceDate || ''}`} 
              />
        </div>
        <div className={classes.flexRowCentered}>
          {
            nextSuggestedDate && <InfoItem 
              label="Suggested Next Service Date"
              centerItem
              clickable={handleSuggestedDateClick}
              value={`${ nextSuggestedDate || ''}`} 
            />
          }
        </div>
    </Paper>
    
    <ServiceHistoryModal
      open={historyModalOpen}
      onClose={() => setHistoryModalOpen(false)}
      site={activeMarker}
      url={url}
    />
  </>
  )
}

export const UnassignedJobsList = ({ unassignedJobs, handleClickAssign, activeMarker }) => {
  const classes = useStyles()
  return (
    <div className={classes.unassignJobsContainer} >
      <List style={{ flex: 1, overflow: 'auto' }}>
        {unassignedJobs.map((job) => {
          let isActiveJob = activeMarker?._id === job._id
          // console.log('unassigned', job)
          let hoursText = `Estimated Hours: ${job?.estimatedHours || 0} `
          if (job?.avgSvcVisit) {
            hoursText = `${hoursText} (${job.avgSvcVisit}h In App)`
          }
          return (
          <ListItem key={job._id} className={isActiveJob ? classes.activeJobItem : classes.unassignedJobItem} onClick={ e => handleClickAssign(job)} >
            <ListItemText
              primary={job.name}
              secondary={`Frequency: ${job.frequency}`}
            />
            <ListItemText
              primary={hoursText}
            />
            <Button variant="contained" color="primary" onClick={ e => handleClickAssign(job) }>
              Assign
            </Button>
          </ListItem>
        )
      })}
    </List>
  </div>
  )
}

export const CustomTabPanel = ({ children, value, index, ...other }) => {
  const classes = useStyles();

  return (
    <TabPanel
      value={value}
      index={index}
      {...other}
      className={classes.tabPanel}
    >
      {children}
    </TabPanel>
  );
};

export function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export const SiteList = ({ nearestSites, handleClickOnSiteNearby, closestMatchSites,  highlightedNearbySite }) => {
  const classes = useStyles();
  // console.log('HhighlightedNearbySite', highlightedNearbySite)
  const dayOrder = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];


  return (
    <div className={classes.siteListContainer}>
      {nearestSites.map((site, index) => {
        // console.log("Nearby site", site)
        const sortedPreferredDays = site?.preferredDays?.sort((a, b) => {
          return dayOrder.indexOf(a) - dayOrder.indexOf(b);
        }) || []
        const preferredDaysDisplay = sortedPreferredDays.join('/') || ''
        let extraStyle = {         
          backgroundColor: 'inherit'
        }
        if (highlightedNearbySite === site._id) {
          extraStyle = {
            // backgroundColor: '#eee',
            border: `2px solid ${site.color}`
          }
        }
        let miles = site?.distance / 1609.34
        // console.log('405. ..miles', miles)
        return (
        <div key={index} className={classes.nearestSiteItemContainer} style={extraStyle} onClick={() => handleClickOnSiteNearby(site)}>
          <div className={classes.colorBar} style={{ backgroundColor: site.color }} />
          <div className={classes.contentContainer}>
            <div className={`${classes.column} ${classes.smallColumn}`}>
              <InfoItem 
                label="Distance" 
                value={`${Math.round(100 * miles) / 100} mi`}
              />
              <InfoItem 
                label="Estimated Hours" 
                value={Math.round(100 * site?.estimatedHours) / 100} 
              />
             
            </div>
            <div className={`${classes.column} ${classes.largeColumn}`}>
              <InfoItem 
                label="Name" 
                value={site?.name}
              />
              <InfoItem 
                label="Frequency" 
                value={`${site?.frequency} ${site?.frequency === 'Bi-Weekly' ? `(${site.evenOrOddWeeks})` : ''}`} 
              />
            </div>
            <div className={`${classes.column} ${classes.largeColumn}`}>
              {
                site.frequency === 'Twice a Week' ? (
                  <InfoItem 
                  label="Preferred Days" 
                  value={preferredDaysDisplay} 
                />
                ) : (
                <InfoItem 
                  label="Preferred Day" 
                  value={site.preferredDay} 
                />
                )
              }
              <InfoItem 
                label="Assigned Crew" 
                value={site.crewName} 
              />
            </div>
          </div>
        </div>
      )})}
    </div>
  );
};